<template>
  <div>
    <el-table :data="normalizeDataTable" :max-height="height">
      <el-table-column
        v-for="(column, index) in columns"
        :key="index"
        :label="column.label"
        :prop="column.prop"
        :width="column.width"
      >
        <template slot-scope="scope">
          <TableColumn :column="column" :row="scope.row" />
        </template>
      </el-table-column>
      <el-table-column
        :label="select.label"
        :filters="mappingLabelOptions"
        :filter-method="onFilter"
        filter-placement="bottom-end"
      >
        <template slot-scope="scope">
          <el-select
            v-model="scope.row[select.columnKey]"
            size="small"
            clearable
            :placeholder="select.placeholder"
            @change="onChange(scope.row)"
          >
            <el-option
              v-for="item in select.options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import TableColumn from "@/components/TableColumn";

export default {
  components: {
    TableColumn,
  },
  props: {
    data: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    height: {
      type: Number,
      required: false,
      default: 464,
    },
    columns: {
      type: Array,
      required: true,
    },
    typeId: {
      type: String,
      required: false,
      default: "id",
    },
    select: {
      type: Object,
      required: true,
    },
    value: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
  },
  computed: {
    normalizeDataTable() {
      return this.data.map((column) => {
        this.value.forEach((value) => {
          if (column[this.typeId] === value[this.typeId]) {
            column[this.select.columnKey] = value[this.select.columnKey];
          }
        });
        return column;
      });
    },
    mappingLabelOptions() {
      return this.select.options.map((e) => {
        e.text = e.label;
        return e;
      });
    },
  },
  methods: {
    onChange() {
      this.$emit(
        "input",
        this.data.filter((e) => e[this.select.columnKey])
      );
    },
    onFilter(value, row) {
      return row[this.select.columnKey] === value;
    },
  },
};
</script>
